import { render, staticRenderFns } from "./ChatGroupCard.vue?vue&type=template&id=50dba571&scoped=true"
import script from "./ChatGroupCard.vue?vue&type=script&lang=js"
export * from "./ChatGroupCard.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupCard.vue?vue&type=style&index=0&id=50dba571&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dba571",
  null
  
)

export default component.exports